import React from 'react'
import { IProps } from './index'
import { Text } from '../../elements/Text'
import { LegalSection } from '../LegalSection'
import styles from './styles-legacy.scss'
import { SecondaryNav } from '../SecondaryNav'
import { useRouter } from 'next/router'
import useTranslate from '../../hooks/useTranslate'

import { LegalContent as LegalContentDefault } from './component'
import { BrandOptions, useBrand } from '../../providers/brandProvider'

export const LegalContent = (props: IProps): React.ReactElement => {
  const theme = useBrand()
  if (theme === BrandOptions.default) {
    return <LegalContentDefault {...props} />
  }
  return <LegalContentLegacy {...props} />
}

const REDIRECT_FROM = 'terms-and-policies'

const HASH_REDIRECTS: Record<string, string> = {
  privacy: '/privacy',
  'support-policy': '/support-policy',
  'cookie-policy': '/cookie-policy',
  security: '/security-policy',
  'security-third-parties': '/security-third-parties',
  'eu-us': '/eu-us-privacy-shield-policy',
  'website-terms': '/website-terms-of-use',
  sla: '/service-level-agreement',
  aup: '/acceptable-use-policy',
  billing: '/how-we-bill',
  'academy-terms': '/academy-terms',
  'data-processing-agreement': '/data-processing-agreement',
}

const LegalContentLegacy = ({
  navigation,
  content,
  pathPrefix,
}: IProps): React.ReactElement | null => {
  const router = useRouter()
  const { translate } = useTranslate()

  const [url, hash] = router.asPath.split('#')
  const urlWithoutQuery = url.split('?')[0]

  if (
    urlWithoutQuery.endsWith(REDIRECT_FROM) &&
    HASH_REDIRECTS[hash] &&
    typeof window === 'object'
  ) {
    // Needs full page reload instead of history push
    window.location.href = `${pathPrefix}` + HASH_REDIRECTS[hash]
    return null
  }

  const getSectionId = () => {
    const slashRegex = /\//g
    const initialDashesRegex = /^-+/
    return content.url.replace(slashRegex, '--').replace(initialDashesRegex, '')
  }

  return (
    <div className="legal">
      <div className="legal-wrapper">
        <div className="legal-heading">
          <Text size="heading">{translate('Terms & Policies')}</Text>
        </div>
        <div className="legal-content">
          <div className="legal-content__directory">
            <SecondaryNav {...navigation} />
          </div>
          <div id={getSectionId()} className="legal-content__section">
            <LegalSection {...content} />
          </div>
        </div>
      </div>
      <style jsx>{styles}</style>
    </div>
  )
}
